import {
    ButtonLink,
    createButtonLink,
} from '@vfde-brix/ws10/button-link';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Mounts an ButtonLink by ID
 */
export const mountButtonLink = (containerId: string): ButtonLink | null => {
    const containerElement = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!containerElement) {
        return null;
    }

    return createButtonLink(containerElement, NO_PATTERN_BUSINESS_LOGIC);
};
